import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import MotionDiv from "../motionDiv";
import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

function WebinairesBlock() {

    return (
            <section id="webinaires" className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <Row>
                        <Col lg={6} md={6} sm={12} className="mt-lg-0 mt-md-0 mt-sm-5">
                            <MotionDiv delay={0.5} classes={''}>
                                <figure className="section-picture">
                                    <img className="photo" src="/images/homepage/webinaires-sensibilisations.png"
                                         alt="Faire du handicap un levier d’engagement collectif"
                                         width={628} height={812}
                                    />
                                </figure>
                            </MotionDiv>
                        </Col>

                        <Col lg={6} md={6} sm={12}>
                            <MotionDiv>
                                <div className="sec-title">
                                    <h2>
                                        Webinaires <span className="formation-title">de sensibilisation </span>
                                    </h2>
                                    <h3>Faire du handicap un levier d’engagement collectif</h3>
                                </div>
                            </MotionDiv>
                            <MotionDiv delay={0.3}>
                                <div className="text mt-30">
                                    <p>

                                        Parce que l’inclusion durable passe par la sensibilisation,
                                        Talents Handicap propose aux entreprises <span>des webinaires clés en main pour informer,
                                        mobiliser et impliquer leurs collaborateurs</span> autour du handicap et de l’inclusion.
                                        <br/>
                                        <br/>
                                        <span>Animés par nos experts,</span> ces formats interactifs et bienveillants transforment
                                        la prise de conscience en engagement concret, <span>à travers des échanges, témoignages
                                        et outils pratiques sur des thématiques clés</span> : handicap invisible, santé mentale,
                                        neurodiversité, management inclusif, RSE...
                                        <br/>
                                        <br/>
                                        🎯 <b>Objectif</b> : aider chaque collaborateur à mieux comprendre le handicap au travail et à devenir acteur de l’inclusion.
                                        <br/>
                                        <br/>
                                        Chaque webinaire est hébergé sur une plateforme digitale personnalisée,
                                        <span>pensée à l’image de votre entreprise</span> - vos couleurs, votre identité,
                                        vos messages - pour offrir à vos collaborateurs <span>une expérience cohérente, fluide et engageante.</span>
                                        <br/>
                                        <br/>
                                        Cet espace dédié leur permet de découvrir le programme, <span>de s’inscrire en quelques clics,
                                        de revoir les replays et d’accéder à des ressources pratiques</span> pour prolonger
                                        la sensibilisation et faciliter l’action au quotidien.
                                        <br/>
                                        <br/>
                                        En alliant expertise, pédagogie et innovation digitale, Talents Handicap fait
                                        de la sensibilisation <span>un levier puissant de cohésion, d’engagement et
                                        de performance durable</span>.

                                    </p>
                                    <div className={'d-flex justify-content-center justify-content-sm-start'}>
                                        <Link to="https://webinaires.talents-handicap.com"
                                              target="_blank"
                                              className="theme-btn btn-style-one mt-3 mb-3 small">
                                            Découvrir nos webinaires de sensibilisation
                                        </Link>
                                    </div>
                                </div>
                            </MotionDiv>
                        </Col>


                    </Row>
                </div>
            </section>
    )
}

export default WebinairesBlock;
